import React, { useMemo, useState } from "react"

import ColumnHeaderGroup from "./Cell Components/column_group_header";
import ColumnHeader from "./Cell Components/column_header";

import tableStyles from './table.module.scss'
import CellDisplay from "./Cell Components/record_cell_display";
import LinkDisplay from "./Cell Components/record_link_display";
import PlateDisplay from "./Cell Components/record_plate_display";

const SortableTable = ({ records, fields, plateType, defaultSort, idField, linkType='none', tableScrolled=false }) => {

    // construct json of field groups and their colspans //
    const fieldGroups = []
    const fieldGroupSpans = {}

    fields.forEach((item) => {
        if (fieldGroups.includes(item['fieldGroup'])) {
            fieldGroupSpans[item['fieldGroup']] += 1
        } else {
            fieldGroups.push(item['fieldGroup'])
            fieldGroupSpans[item['fieldGroup']] = 1
        }
    })

    // sorting mechanics //
    // state //
    const [sortField, setSortField] = useState(defaultSort)

    // func for handling click //
    const handleSortRequest = (field) => {

        var direction = 'dsc'

        if (sortField['field'] === field && sortField['direction'] === 'dsc') {
            direction = 'asc'
        }

        setSortField({
            'field' : field,
            'direction' : direction
        })
    }

    // func for sorting copy of data //
    // will fire whenevr state changes //
    const sortedData = useMemo(() => {

        // copy data //
        let sortableData = [...records]
        
        // sort //
        sortableData.sort((a, b) => {
            if (parseFloat(a[sortField['field']]) < parseFloat(b[sortField['field']])) {
                return sortField['direction'] === 'asc' ? -1 : 1
            } else if (parseFloat(a[sortField['field']]) > parseFloat(b[sortField['field']])) {
                return sortField['direction'] === 'asc' ? 1 : -1
            } else {
                return 0
            }
        })

        // return sorted data //
        return sortableData

    }, [records, sortField])

    return (

        <table className={tableStyles.sortable_table}>
            <thead>
                <tr className={tableStyles.header_group_row}>
                    <th colSpan={1} aria-label='spacing'></th>
                    {fieldGroups.map((fieldGroupItem) => {
                        return (
                            <ColumnHeaderGroup
                                key={`${fieldGroupItem}_header_group`}
                                displayName={fieldGroupItem}
                                columnSpan={fieldGroupSpans[fieldGroupItem]}
                            />
                        )
                    })}
                </tr>
                <tr className={tableStyles.header_row}>
                    <th colSpan={1} aria-label='spacing'></th>
                    {fields.map((fieldItem) => {
                        return (
                            <th key={`${fieldItem.refName}_header`}>
                                <button
                                    type='button'
                                    className={tableStyles.sortButton}
                                    onClick={() => handleSortRequest(fieldItem.refName)}
                                >
                                    <ColumnHeader
                                        displayName={fieldItem.displayName}
                                        refName={fieldItem.refName}
                                        currentSort={sortField['field']}
                                        sortDirection={sortField['direction']}
                                    />
                                </button>
                            </th>
                        )
                    })}
                </tr>
            </thead>
            <tbody>
                {sortedData.map((node, index) => {
                    return (
                        <tr className={tableStyles.record_tr} key={`${node[idField]}_record`}>
                            <td>
                                <LinkDisplay
                                    linkType={linkType}
                                    nodeData={node}
                                >
                                    <PlateDisplay
                                        plateType={plateType}
                                        nodeData={node}
                                        index={index}
                                        sortDirection={sortField['direction']}
                                        tableScrolled={tableScrolled}
                                    />
                                </LinkDisplay>
                            </td>
                            {fields.map((fieldItem) => {
                                return (
                                    <td key={`${node[idField]}_${fieldItem['refName']}`}>
                                        <LinkDisplay
                                            linkType={linkType}
                                            nodeData={node}
                                        >
                                                <CellDisplay
                                                    cellContent={node[fieldItem['refName']]}
                                                    displayType={fieldItem['displayType']}
                                                    displayParams={fieldItem['displayParams']}
                                                />
                                        </LinkDisplay>
                                    </td>
                                )
                            })}    
                        </tr>
                    )
                })}
            </tbody>
        </table>

    )
}

export default SortableTable